module.exports = __webpack_public_path__ + "img/resident.0f8d38d8.png";